import cn from 'classnames';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { AppBundle } from 'api/optimalprint-sdk.d';
import getCurrentCategory from 'store/category/selector/getCurrentCategory';
import AppLink from '../Link/Link';
import EllipsisIcon from './EllipsisIcon';
import styles from './BreadcrumbsMobile.module.scss';

const isLast = (list: any[], index: number) => index === list.length - 1;

const Separator = () => <span>&nbsp;/&nbsp;</span>;

interface Props {
  extraCrumb?: string;
}

const BreadcrumbsMobile = ({ extraCrumb }: Props) => {
  const [isExpanded, setIsExpand] = useState(false);
  const category = useSelector(getCurrentCategory);

  if (!category) {
    return null;
  }
  const breadCrumbs = (
    extraCrumb ? [...category.breadcrumbs, { title: extraCrumb }] : category.breadcrumbs
  ) as AppBundle.Api.Response.CategoryPage.V1.CategoryPageGetV1Response.Breadcrumb[];

  const handleClick = () => {
    if (!isExpanded) {
      setIsExpand(true);
    }
  };

  const breadCrumbsFrame = isExpanded ? breadCrumbs : breadCrumbs.slice(-2);

  return (
    <div className={styles.breadcrumbs} onClick={handleClick}>
      {!isExpanded && (
        <>
          <span className={styles.ellipsis}>
            <EllipsisIcon />
          </span>
          <Separator />
        </>
      )}
      {breadCrumbsFrame.map((crumb, index) => (
        <React.Fragment key={`bc_${index}`}>
          {crumb.url && !isLast(breadCrumbsFrame, index) && (
            <AppLink to={crumb.url} external={index < 2} className={cn({ [styles.ignoreClick]: !isExpanded })}>
              {crumb.title}
            </AppLink>
          )}
          {(!crumb.url || isLast(breadCrumbsFrame, index)) && <span className={styles.noLink}>{crumb.title}</span>}
          {!isLast(breadCrumbsFrame, index) && <Separator />}
        </React.Fragment>
      ))}
    </div>
  );
};

export default BreadcrumbsMobile;
